// extracted by mini-css-extract-plugin
module.exports = {"width":"DetailsBox_width__2lmEx","direction":"DetailsBox_direction__3Rv8b","list":"DetailsBox_list__2ouWb"};